import { useContext } from "react";

import {
  MayaSidebarContext,
  type MayaSidebarContextValue,
} from "./sidebar-context";

export const useMayaSidebar = (): MayaSidebarContextValue => {
  const ctx = useContext(MayaSidebarContext);
  if (!ctx) {
    throw new Error("useMayaSidebar must be used within a MayaSidebarProvider");
  }
  return ctx;
};
